<template>
  <span class="gt-list-tree-option" :style="{ paddingLeft: depth * 1.25 + 'rem' }">
    <span v-if="depth" class="gt-list-tree-option__branch">└</span>
    <span :class="{ 'fw-semibold': hasChildren }">{{ label }}</span>
  </span>
</template>

<script>
/**
 * Opción de un selector de lista con jerarquía: la sangría de su nivel, como la muestra
 * el editor de la lista. Los padres van resaltados porque elegirlos incluye a sus hijos.
 */
export default {
  name: "ListTreeOptionLabel",
  props: {
    label: { type: String, default: "" },
    /** Nivel en el árbol de la lista (0 = raíz). */
    depth: { type: Number, default: 0 },
    hasChildren: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.gt-list-tree-option {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.gt-list-tree-option__branch {
  opacity: 0.5;
}
</style>
